import React from 'react';
import classnames from 'classnames';

import { Section, Layout, SEO } from '..';

import stefan from './assets/stefan.png';
import ally from './assets/ally.png';
import chest from './assets/chest.png';

import style from './StoryPage.module.less';

export const StoryPage = () => (
  <Layout>
    <SEO title="The Story" description="After receiving a disturbing “blast from the past” in the shape of a suspicious package, two long time partners who, having moved on from each other, are thrust back together when the Cryptic Killer reappears." />

    <Section className={classnames(style.section, style.firstSection)}>
      <div className={style.content}>
        <h1>The story</h1>

        <div className={style.row}>
          <div className={style.text}>
            <p>After getting an anonymous tip to check out a warehouse in the shipping areas of their respective cities, two former partners arrive at their scenes to find a suspicious chest has been left for them.</p>
            <p>They realise immediately the similarities to the crime scenes from a case they both worked on that had long gone cold but has recently reopened, that of the Cryptic Killer, now it appears they are the killer's next targets.</p>
            <p>After realising the dangerous situation that they are in, the detectives reconnected with each other virtually but aren't confident they can solve the cryptic puzzles that they know lie ahead.</p>
            <p>They have called on you for your expertise in puzzle solving and code-breaking in hope that your team can assist these detectives and help them escape the clutches of the killer.</p>
          </div>
          <div className={style.image}>
            <img src={chest} alt="Chest" />
          </div>
        </div>

        <div className={classnames(style.row, style.ally)}>
          <div className={style.text}>
            <h2>Allison Abernathy ("Ally" for short)</h2>
            <p>Ally grew up in a police family. Just like her great-grandfather, her grandfather and father before her she was always destined to join the police. Police blood ran through her veins. When Ally put her mind to something, she would achieve it and generally let nothing stop her in her tracks. Even growing up, where she focused on boxing, it was never enough that she won the best titles; she wanted to be the best. She always felt she had to go one step further. She was the best at the police school, always attentive, focused, and determined. She graduated with honors and was immediately assigned to the criminal department in Glasgow.</p>
            <p>Her streak of success was interrupted when she worked with the Polish police to capture the Cryptic Killer. It was then that she was seriously injured, and the perpetrator fled. In the hospital, she met her current husband, with whom she has two sons.</p>
            <p>After a few years, she returned to the service and has since only dealt with smaller, less complex cases. However, she is still an uncompromising investigator, while at home, she is always a caring mother and wife.</p>
          </div>
          <div className={style.image}>
            <img src={ally} alt="Ally" />
          </div>
        </div>

        <div className={classnames(style.row, style.stefan)}>
          <div className={style.text}>
            <h2>Steve "Old Dog" Kowalski</h2>
            <p>Old before his time, even as a young boy playing games with his friends, Old Dog, knew he would be a police officer. He hadn't even finished his first year at the academy when he caught a dangerous criminal; this was to be the first of many during his successful career.</p>
            <p>Eventually, he became the Polish police commissioner. While his career has been a success, his personal life has sadly not. He has always been known as a "ladies man", which may be true, but he is actually a loner and stuck in his ways.</p>
            <p>"Married to the job", he spends his evenings in his favourite armchair, sipping a cup of black coffee as black as coal, and listening to his favourite blues records, while he goes over his cases.</p>
            <p>His devotion to solving them has never been tested as much as it was by the Cryptic Killer. With this killer back on the loose, he and his Scottish partner won't stop until this mystery is solved once and for all.</p>
          </div>
          <div className={style.image}>
            <img src={stefan} alt="Stefan" />
          </div>
        </div>
      </div>
    </Section>
  </Layout>
);
